// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2cixE","content":"GlobalSearch_content__2M5-M"};